const productCategory = () => import('@/pages/product/category/index.vue');

export default [{
    path: '/product/category',
    component: productCategory,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '产品分类',
        activeRoute: '/product/category'
    }]
}];